function RequestInfo() {
  const header = document.querySelector('.header-final');
  const mobileHeader = document.querySelector('.header-final__left');
  const mobileSubMenu = document.querySelector('.header-final__right');
  const sidebar = document.querySelector('.request-info');
  const trigger = document.querySelector('.request-info-trigger');
  const alertText = document.querySelector('aside.alert-text');

  function setPosition() {
    const alertTextHeight = alertText ? alertText.offsetHeight : 0;
    const desktopHeight = header.offsetHeight + alertTextHeight;
    const mobileHeaderHeight = mobileHeader.offsetHeight;
    const mobileSubMenuHeight = mobileSubMenu.offsetHeight;
    const mobileHeight = mobileHeaderHeight + mobileSubMenuHeight + alertTextHeight;
    const position = window.matchMedia('(max-width: 1390px)').matches ? mobileHeight : desktopHeight;
    sidebar.setAttribute('style', `--position: ${position}px`);
  }

  if (header && sidebar) {
    const observeR = new ResizeObserver(entries => {
      entries.forEach(entry => {
        setPosition();
      });
    });

    observeR.observe(header);
  }

  if (trigger && sidebar) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      setPosition();
      sidebar.classList.toggle('active');
      trigger.classList.toggle('active');
    });
  }
}

export default RequestInfo;